/* ÄRA story landing (sections/magnum-ara-story.liquid). Scoped to [data-ara-story].
   The section can be rendered twice (render_part hero / after_hero), so each root inits on its own
   and the hero, buy box and bar are looked up page-wide when they live in the other root. */
(() => {
  if (window.__araStoryLoaded) return;
  window.__araStoryLoaded = true;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  let barResize = null; /* one window resize handler for the sticky bar, replaced on shopify:section:load */
  let freqOutside = null; /* one document pointerdown handler for the bar's frequency drop-up, same rule */
  let freqEsc = null; /* document Escape handler, attached only while the drop-up is open */
  let loadReset = null; /* one pageshow/visibilitychange pair for the ATC spinner, replaced on shopify:section:load */

  function formatMoney(cents, format) {
    const fmt = format || '${{amount}}';
    const n = Number(cents) || 0;
    const withDelims = (num, precision, thousands, decimal) => {
      const fixed = (num / 100).toFixed(precision);
      const parts = fixed.split('.');
      const whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return parts[1] ? whole + decimal + parts[1] : whole;
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (m, key) => {
      switch (key) {
        case 'amount_no_decimals': return withDelims(n, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelims(n, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelims(n, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return withDelims(n, 2, "'", '.');
        default: return withDelims(n, 2, ',', '.');
      }
    });
  }

  function headerOffset() {
    const hdr = document.querySelector('.section-header');
    if (!hdr) return 0;
    const pos = getComputedStyle(hdr).position;
    if (pos !== 'sticky' && pos !== 'fixed') return 0;
    return Math.round(hdr.getBoundingClientRect().height);
  }

  function init(root) {
    if (!root || root.dataset.araReady) return;
    root.dataset.araReady = '1';
    const motion = !reduce.matches;
    root.classList.toggle('ara-motion', motion);
    root.classList.add('ara-js');

    const setTop = () => root.style.setProperty('--ara-top', headerOffset() + 'px');

    /* steam: centre it on the mug opening = section settings steam_x / steam_y (% of the photo; 69 / 65.5 for the current hero).
       Maps photo coords through object-fit:cover using the img's live object-position + natural size,
       so a breakpoint that changes object-position (or a non-square photo) keeps the steam on the mug. */
    const media = root.querySelector('[data-ara-media]');
    const steamEl = media && media.querySelector('[data-ara-steam]');
    const heroImg = media && media.querySelector(':scope > img');
    const placeSteam = () => {
      if (!steamEl || !heroImg) return;
      const W = media.clientWidth, H = media.clientHeight;
      if (!W || !H) return;
      const iw = heroImg.naturalWidth || 1080, ih = heroImg.naturalHeight || 1080;
      const k = Math.max(W / iw, H / ih), RW = iw * k, RH = ih * k;
      const pos = getComputedStyle(heroImg).objectPosition.split(' ');
      const pct = (v, free) => v.endsWith('%') ? parseFloat(v) / 100 * free : parseFloat(v) || 0;
      const offX = pct(pos[0] || '50%', W - RW), offY = pct(pos[1] || '50%', H - RH);
      const fx = (parseFloat(media.dataset.steamX) || 69) / 100, fy = (parseFloat(media.dataset.steamY) || 65.5) / 100;
      const sw = 0.2 * RW, sh = 0.5 * RH, cx = offX + fx * RW, base = offY + fy * RH;
      steamEl.style.setProperty('--sx', (cx - sw / 2).toFixed(1) + 'px');
      steamEl.style.setProperty('--sy', (base - sh).toFixed(1) + 'px');
      steamEl.style.setProperty('--sw', sw.toFixed(1) + 'px');
      steamEl.style.setProperty('--sh', sh.toFixed(1) + 'px');
    };
    placeSteam();
    if (heroImg && !heroImg.complete) heroImg.addEventListener('load', placeSteam, { once: true });
    if (media) {
      if ('ResizeObserver' in window) new ResizeObserver(placeSteam).observe(media); else window.addEventListener('resize', placeSteam, { passive: true });
    }

    setTop();

    const io = 'IntersectionObserver' in window ? new IntersectionObserver((es) => {
      es.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('ara-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.12 }) : null;
    root.querySelectorAll('.ara-rv,[data-board],[data-cups]').forEach((el) => (io ? io.observe(el) : el.classList.add('ara-in')));

    /* "CLUMPS" dissolves into powder and re-forms, looping while on screen */
    const cl = root.querySelector('[data-dissolve]');
    if (cl && motion && io) {
      const word = cl.textContent.trim();
      cl.textContent = '';
      const rnd = (a, b) => a + Math.random() * (b - a);
      [...word].forEach((ch, idx) => {
        const s = document.createElement('span');
        s.className = 'ara-ch';
        s.textContent = ch;
        s.style.setProperty('--ara-x', rnd(-30, 50).toFixed(0) + 'px');
        s.style.setProperty('--ara-y', rnd(-70, -20).toFixed(0) + 'px');
        s.style.setProperty('--ara-r', rnd(-25, 25).toFixed(0) + 'deg');
        s.style.setProperty('--ara-i', idx * 70 + 'ms');
        cl.appendChild(s);
      });
      /* loop: dissolve -> hold 1.8s -> re-form -> hold 2.2s -> repeat, only while on screen */
      const SETTLE = 1750;
      let timers = [];
      const later = (fn, ms) => timers.push(setTimeout(fn, ms));
      const stop = () => { timers.forEach(clearTimeout); timers = []; };
      const makeDust = () => {
        cl.querySelectorAll('.ara-dust').forEach((d) => d.remove());
        [...cl.querySelectorAll('.ara-ch')].forEach((s, idx) => {
          for (let d = 0; d < 9; d++) {
            const p = document.createElement('i');
            p.className = 'ara-dust';
            p.style.setProperty('--ara-cx', (s.offsetLeft + s.offsetWidth * rnd(0.2, 0.8)).toFixed(0) + 'px');
            p.style.setProperty('--ara-cy', (s.offsetTop + s.offsetHeight * rnd(0.25, 0.8)).toFixed(0) + 'px');
            p.style.setProperty('--ara-dx', rnd(-40, 70).toFixed(0) + 'px');
            p.style.setProperty('--ara-dy', rnd(-110, -30).toFixed(0) + 'px');
            p.style.setProperty('--ara-s', rnd(2, 5).toFixed(1) + 'px');
            p.style.setProperty('--ara-i', (idx * 70 + rnd(0, 180)).toFixed(0) + 'ms');
            cl.appendChild(p);
          }
        });
      };
      const dissolve = () => {
        makeDust();
        void cl.offsetWidth;
        cl.classList.add('ara-gone');
        later(reform, SETTLE + 1800);
      };
      const reform = () => {
        cl.classList.remove('ara-gone');
        later(dissolve, SETTLE + 2200);
      };
      const obs = new IntersectionObserver((es) => {
        stop();
        if (es[0].isIntersecting) {
          later(dissolve, 450);
        } else {
          cl.classList.remove('ara-gone');
        }
      }, { threshold: 0.5 });
      obs.observe(cl);
    } else if (cl) {
      cl.parentElement.classList.add('ara-no-motion-note');
    }

    /* the stir: swirl turns with scroll; pinned on desktop (>=1000px) only */
    const stir = root.querySelector('[data-ara-stir]');
    const disc = stir && stir.querySelector('[data-ara-disc]');
    const steps = stir ? [...stir.querySelectorAll('.ara-steps li')] : [];
    const wide = window.matchMedia('(min-width: 1000px)');
    let ticking = false;
    function update() {
      ticking = false;
      if (!motion || !stir || !disc) return;
      const top = parseFloat(getComputedStyle(root).getPropertyValue('--ara-top')) || 0;
      const r = stir.getBoundingClientRect();
      const pinned = stir.classList.contains('ara-pinned');
      const stickyEl = stir.querySelector('.ara-stir-sticky');
      const view = stickyEl ? stickyEl.offsetHeight : window.innerHeight - top;
      const span = pinned ? r.height - view : r.height + window.innerHeight;
      const raw = pinned ? (top - r.top) / span : (window.innerHeight - r.top) / span;
      const p = Math.min(1, Math.max(0, raw));
      disc.style.transform = `rotate(${(p * 330).toFixed(1)}deg)`;
      if (pinned && steps.length) {
        const on = Math.min(steps.length - 1, Math.floor(p * (steps.length + 0.001)));
        steps.forEach((s, k) => s.classList.toggle('ara-on', k === on));
      }
    }
    const setPin = () => {
      if (stir) stir.classList.toggle('ara-pinned', motion && wide.matches);
      setTop();
      update();
    };
    window.addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    window.addEventListener('resize', () => { setTop(); update(); }, { passive: true });
    if (wide.addEventListener) wide.addEventListener('change', setPin);
    setPin();

    /* smooth scroll for every in-page "Shop" CTA */
    const buy = root.querySelector('[data-ara-buy]') || document.querySelector('[data-ara-buy]');
    root.querySelectorAll('a[href="#ara-buy"]').forEach((a) => a.addEventListener('click', (e) => {
      if (!buy) return;
      e.preventDefault();
      buy.scrollIntoView({ behavior: motion ? 'smooth' : 'auto', block: 'start' });
      if (history.replaceState) history.replaceState(null, '', '#ara-buy');
    }));

    /* flavour + plan state, shared by the flavour section, the buy box and the bar */
    const jsonEl = root.querySelector('[data-ara-json]');
    const form = root.querySelector('#AraBuyForm');
    if (!jsonEl || !form) return;
    let data;
    try { data = JSON.parse(jsonEl.textContent); } catch (err) { return; }
    const byId = {};
    data.variants.forEach((v) => { byId[String(v.id)] = v; });

    const chips = [...form.querySelectorAll('[data-ara-chip]')];
    const flavPicks = [...root.querySelectorAll('[data-ara-flav]')];
    const planInputs = [...form.querySelectorAll('[data-ara-plan]')];
    const freq = form.querySelector('[data-ara-freq]');
    const spInput = form.querySelector('[data-ara-selling-plan]');
    const spParent = spInput ? spInput.parentNode : null;
    const submit = form.querySelector('[data-ara-submit]');
    const label = form.querySelector('[data-ara-buylabel]');
    const percup = form.querySelector('[data-ara-percup]');
    const subPriceEl = form.querySelector('[data-ara-sub-price]');
    const wasEl = form.querySelector('[data-ara-was]');
    const oncePriceEl = form.querySelector('[data-ara-once-price]');
    const barline = root.querySelector('[data-ara-barline]');
    const flavCta = root.querySelector('[data-ara-flav-cta]');
    const flavDesc = root.querySelector('[data-ara-flav-desc]');
    const stageImgs = [...root.querySelectorAll('.ara-stage-img')];
    const qtyInput = form.querySelector('[data-ara-qty-input]');
    const qtySteps = [...form.querySelectorAll('[data-ara-qty-step]')];
    const qtyMax = qtyInput ? Math.max(1, parseInt(qtyInput.max, 10) || 10) : 1;
    const clampQty = (n) => Math.min(qtyMax, Math.max(1, Number.isFinite(n) ? Math.round(n) : 1));
    /* sticky bar mirrors of the buy-box controls (flavour, plan, qty). They sit outside #AraBuyForm and
       have no form-field names, so nothing posts twice; the bar ATC proxies a click on the buy-box submit. */
    const bar = root.querySelector('[data-ara-bar]');
    const barFlav = bar ? bar.querySelector('[data-ara-bar-flav]') : null;
    const barPlans = bar ? [...bar.querySelectorAll('[data-ara-bar-plan]')] : [];
    const barQty = bar ? bar.querySelector('[data-ara-bar-qty-input]') : null;
    const barSteps = bar ? [...bar.querySelectorAll('[data-ara-bar-qty-step]')] : [];
    const barPrice = bar ? bar.querySelector('[data-ara-bar-price]') : null;
    const barVerb = bar ? bar.querySelector('[data-ara-bar-verb]') : null;
    const barSubmit = bar ? bar.querySelector('[data-ara-bar-submit]') : null;
    /* subscription frequency drop-up above the bar's Subscribe segment; mirrors the buy-box .ara-freq select */
    const barFreq = bar ? bar.querySelector('[data-ara-bar-freq]') : null;
    const freqOpts = barFreq ? [...barFreq.querySelectorAll('[data-ara-bar-freq-opt]')] : [];
    const barSub = barPlans.find((i) => i.value === 'sub') || null;
    if (barFreq) barFreq.inert = true;
    function freqIsOpen() { return !!barFreq && !barFreq.hidden; }
    function openFreq(focusChecked) {
      if (!barFreq || !barSub || !freq) return;
      if (state.plan !== 'sub') setPlan('sub');
      barFreq.hidden = false;
      barFreq.inert = false;
      barSub.setAttribute('aria-expanded', 'true');
      bar.classList.add('ara-freq-open');
      document.documentElement.style.setProperty('--ara-freq-h', barFreq.offsetHeight + 'px');
      if (freqEsc) document.removeEventListener('keydown', freqEsc);
      freqEsc = onFreqEsc;
      document.addEventListener('keydown', freqEsc);
      if (focusChecked) {
        const c = freqOpts.find((o) => o.checked) || freqOpts[0];
        if (c) c.focus({ preventScroll: true });
      }
    }
    function closeFreq(returnFocus) {
      if (!freqIsOpen()) return;
      const hadFocus = barFreq.contains(document.activeElement);
      barFreq.hidden = true;
      barFreq.inert = true;
      barSub.setAttribute('aria-expanded', 'false');
      bar.classList.remove('ara-freq-open');
      if (freqEsc === onFreqEsc) { document.removeEventListener('keydown', freqEsc); freqEsc = null; }
      optKey = '';
      if ((returnFocus || hadFocus) && !bar.inert) barSub.focus({ preventScroll: true });
    }
    /* Escape anywhere while open (Safari leaves focus on body after a mouse open); focus returns to
       Subscribe only when it was inside the bar or the drop-up */
    function onFreqEsc(e) {
      if (e.key !== 'Escape' || !freqIsOpen()) return;
      e.preventDefault();
      closeFreq(bar.contains(document.activeElement));
    }
    let optKey = ''; /* key currently held on an option; cleared on keyup / focus leaving the list */
    let swallowKeyClick = false; /* after a keyboard open, ignore the one keyup-originated click on an option */

    const checkedChip = chips.find((c) => c.checked) || chips.find((c) => !c.disabled) || chips[0];
    const state = {
      id: checkedChip ? checkedChip.value : String(data.variants[0].id),
      plan: ((planInputs.find((i) => i.checked) || {}).value) || 'once',
      qty: qtyInput ? clampQty(parseInt(qtyInput.value, 10)) : 1
    };
    const priceFor = (v) => {
      if (state.plan === 'sub' && freq && v.plans[freq.value] != null) return v.plans[freq.value];
      return v.price;
    };
    let shown = priceFor(byId[state.id]) * state.qty;
    let raf = 0;

    function paintLabel() {
      const v = byId[state.id];
      if (!v.available) { label.textContent = data.soldOut; return; }
      const verb = state.plan === 'sub' ? data.verbSub : data.verbOnce;
      label.textContent = `${verb} · ${v.short} · ${formatMoney(Math.round(shown), data.moneyFormat)}`;
    }
    function tweenPrice(to) {
      cancelAnimationFrame(raf);
      if (!motion) { shown = to; paintLabel(); return; }
      const from = shown;
      const t0 = performance.now();
      const step = (t) => {
        const k = Math.min(1, (t - t0) / 450);
        shown = from + (to - from) * (1 - Math.pow(1 - k, 3));
        paintLabel();
        if (k < 1) raf = requestAnimationFrame(step);
      };
      raf = requestAnimationFrame(step);
    }
    function render(animate) {
      const v = byId[state.id];
      if (!v) return;
      const price = priceFor(v);
      document.querySelectorAll('[data-ara-story]').forEach((r) => r.style.setProperty('--ara-flavour', v.tint));
      stageImgs.forEach((el) => el.classList.toggle('ara-on', el.dataset.variant === state.id));
      chips.forEach((c) => { c.checked = c.value === state.id; });
      planInputs.forEach((i) => { i.checked = i.value === state.plan; });
      barPlans.forEach((i) => { i.checked = i.value === state.plan; });
      if (barFlav) barFlav.value = state.id;
      if (freq) freqOpts.forEach((o) => {
        o.checked = o.value === freq.value;
        const pe = o.parentNode.querySelector('[data-ara-bar-freq-price]');
        if (pe) pe.textContent = v.plans[o.value] != null ? formatMoney(v.plans[o.value], data.moneyFormat) : '';
      });
      if (state.plan !== 'sub') closeFreq(false);
      flavPicks.forEach((c) => { c.checked = c.value === state.id; });
      if (freq) freq.disabled = state.plan !== 'sub';
      if (spInput) {
        if (state.plan === 'sub') {
          spInput.value = freq ? freq.value : spInput.value;
          spInput.disabled = false;
          if (!spInput.isConnected) spParent.appendChild(spInput);
        } else if (spInput.isConnected) {
          spInput.remove();
        }
      }
      if (subPriceEl && freq && v.plans[freq.value] != null) subPriceEl.textContent = formatMoney(v.plans[freq.value], data.moneyFormat);
      if (wasEl) wasEl.textContent = formatMoney(v.price, data.moneyFormat);
      if (oncePriceEl) oncePriceEl.textContent = formatMoney(v.price, data.moneyFormat);
      const per = formatMoney(Math.round(price / data.servings), data.moneyFormat);
      if (percup) percup.textContent = per;
      if (barline) barline.textContent = `${v.short} · ${per} ${data.perCupSuffix}`;
      const flavOpt = flavPicks.find((c) => c.value === state.id);
      if (flavCta) flavCta.textContent = (flavOpt && flavOpt.dataset.araCta) || `${data.flavCtaPrefix} ${v.name}`;
      if (flavDesc && flavOpt && flavOpt.dataset.araDesc && flavDesc.textContent !== flavOpt.dataset.araDesc) flavDesc.textContent = flavOpt.dataset.araDesc;
      if (submit) submit.disabled = !v.available;
      if (qtyInput) {
        qtyInput.value = String(state.qty);
        qtySteps.forEach((b) => { b.disabled = b.dataset.araQtyStep === '-1' ? state.qty <= 1 : state.qty >= qtyMax; });
      }
      if (barQty) {
        barQty.value = String(state.qty);
        barSteps.forEach((b) => { b.disabled = b.dataset.araBarQtyStep === '-1' ? state.qty <= 1 : state.qty >= qtyMax; });
      }
      const total = price * state.qty;
      if (barPrice) barPrice.textContent = formatMoney(total, data.moneyFormat);
      if (barVerb) barVerb.textContent = !v.available ? data.soldOut : (state.plan === 'sub' ? data.verbSub : data.verbOnce);
      if (barSubmit) barSubmit.disabled = !v.available;
      if (animate) tweenPrice(total); else { cancelAnimationFrame(raf); shown = total; paintLabel(); }
    }
    const pickVariant = (id) => { state.id = String(id); render(false); };
    chips.forEach((c) => c.addEventListener('change', () => pickVariant(c.value)));
    flavPicks.forEach((c) => c.addEventListener('change', () => pickVariant(c.value)));
    const setPlan = (p) => { state.plan = p; render(true); };
    planInputs.forEach((i) => i.addEventListener('change', () => { if (i.checked) setPlan(i.value); }));
    if (freq) freq.addEventListener('change', () => render(false));
    const setQty = (n) => { state.qty = clampQty(n); render(false); };
    qtySteps.forEach((b) => b.addEventListener('click', () => setQty(state.qty + Number(b.dataset.araQtyStep))));
    if (qtyInput) {
      qtyInput.addEventListener('input', () => {
        const n = parseInt(qtyInput.value, 10);
        if (Number.isFinite(n)) { state.qty = clampQty(n); if (n !== state.qty) qtyInput.value = String(state.qty); render(false); }
      });
      qtyInput.addEventListener('change', () => setQty(parseInt(qtyInput.value, 10)));
      qtyInput.addEventListener('blur', () => setQty(parseInt(qtyInput.value, 10)));
    }
    if (barFlav) barFlav.addEventListener('change', () => pickVariant(barFlav.value));
    barPlans.forEach((i) => i.addEventListener('change', () => {
      if (!i.checked) return;
      setPlan(i.value);
      if (i.value === 'sub') openFreq(false); else closeFreq(false);
    }));
    /* Subscribe opens the drop-up on every activation, even when already checked. Arrow keys open it
       without moving focus (radio-group arrows keep working); Space/Enter open it and focus the checked option. */
    let planKey = '';
    if (freqEsc) { document.removeEventListener('keydown', freqEsc); freqEsc = null; }
    barPlans.forEach((i) => {
      i.addEventListener('keydown', (e) => {
        if (e.repeat) { if (i === barSub && (e.key === ' ' || e.key === 'Spacebar' || e.key === 'Enter')) e.preventDefault(); return; }
        planKey = e.key;
        if (e.key === 'Escape' && freqIsOpen()) { e.preventDefault(); closeFreq(true); }
        else if (i === barSub && (e.key === ' ' || e.key === 'Spacebar' || e.key === 'Enter')) {
          /* Space on an already-checked radio fires no click/change, so open here. The keyup that follows
             lands on the focused option; swallowKeyClick makes the option click path ignore that one echo. */
          e.preventDefault();
          planKey = '';
          swallowKeyClick = true;
          if (state.plan !== 'sub') { barSub.checked = true; setPlan('sub'); }
          openFreq(true);
        }
      });
      i.addEventListener('click', () => {
        const k = planKey;
        planKey = '';
        if (i === barSub) openFreq(k === ' ');
      });
    });
    const applyFreq = (val) => {
      if (!freq) return;
      if (state.plan !== 'sub') setPlan('sub');
      if (freq.value !== val) {
        freq.value = val;
        freq.dispatchEvent(new Event('change', { bubbles: true }));
      }
    };
    /* options: arrows move + apply (stay open); pointer click, Space, Enter or an assistive-tech click
       (detail 0, no key held) apply + close, focus back to Subscribe */
    const isActKey = (k) => k === ' ' || k === 'Spacebar' || k === 'Enter';
    freqOpts.forEach((o) => {
      o.addEventListener('change', () => { if (o.checked) applyFreq(o.value); });
      o.addEventListener('keydown', (e) => {
        if (e.repeat) { if (isActKey(e.key)) e.preventDefault(); return; }
        optKey = e.key;
        if (isActKey(e.key)) { e.preventDefault(); optKey = ''; swallowKeyClick = false; applyFreq(o.value); closeFreq(true); }
      });
      o.addEventListener('click', (e) => {
        if (e.detail > 0) { applyFreq(o.value); closeFreq(true); return; }
        if (swallowKeyClick) { swallowKeyClick = false; return; }
        if (optKey && optKey.indexOf('Arrow') === 0) return;
        applyFreq(o.value);
        closeFreq(true);
      });
    });
    /* keyup clears after the key's own default action (a keyup-originated click) has run */
    const clearKeys = () => { optKey = ''; setTimeout(() => { swallowKeyClick = false; }, 0); };
    if (barFreq) {
      barFreq.addEventListener('keyup', clearKeys);
      barFreq.addEventListener('focusout', (e) => { if (!barFreq.contains(e.relatedTarget)) optKey = ''; });
      barFreq.addEventListener('pointerdown', () => { swallowKeyClick = false; optKey = ''; });
    }
    if (barSub) barSub.addEventListener('keyup', clearKeys);
    if (freqOutside) document.removeEventListener('pointerdown', freqOutside, true);
    freqOutside = null;
    if (barFreq && barSub) {
      freqOutside = (e) => {
        if (freqIsOpen() && !barFreq.contains(e.target) && !barSub.parentNode.contains(e.target)) closeFreq(false);
      };
      document.addEventListener('pointerdown', freqOutside, true);
    }
    barSteps.forEach((b) => b.addEventListener('click', () => setQty(state.qty + Number(b.dataset.araBarQtyStep))));
    if (barQty) {
      barQty.addEventListener('input', () => {
        const n = parseInt(barQty.value, 10);
        if (Number.isFinite(n)) { state.qty = clampQty(n); if (n !== state.qty) barQty.value = String(state.qty); render(false); }
      });
      barQty.addEventListener('change', () => setQty(parseInt(barQty.value, 10)));
      barQty.addEventListener('blur', () => setQty(parseInt(barQty.value, 10)));
    }
    if (barSubmit && submit) barSubmit.addEventListener('click', (e) => {
      e.preventDefault();
      if (barQty) setQty(parseInt(barQty.value, 10));
      submit.click();
    });
    form.addEventListener('submit', () => { if (qtyInput) qtyInput.value = String(clampQty(parseInt(qtyInput.value, 10))); }, true);

    /* ATC loading state on BOTH buttons. Runs on the form's submit event (not click) so a native constraint-validation
       failure never strands a spinner. Never sets .disabled (that would drop name="add" from the POST). */
    const statusEl = form.querySelector('[data-ara-status]');
    const loadBtns = [submit, barSubmit].filter(Boolean);
    let loading = false;
    let loadTimer = 0;
    let wasHidden = false;
    const setLoading = (on) => {
      loading = on;
      clearTimeout(loadTimer);
      loadBtns.forEach((b) => {
        b.classList.toggle('ara-loading', on);
        if (on) { b.setAttribute('aria-busy', 'true'); b.setAttribute('aria-disabled', 'true'); }
        else { b.removeAttribute('aria-busy'); b.removeAttribute('aria-disabled'); }
      });
      if (statusEl) statusEl.textContent = on ? (data.adding || '') : '';
      if (on) loadTimer = setTimeout(() => setLoading(false), 8000);
    };
    form.addEventListener('submit', (e) => {
      /* the ONE allowed preventDefault: a duplicate submit while the first POST is in flight (e.g. Enter twice) */
      if (loading) { e.preventDefault(); return; }
      if (!submit || submit.disabled) return; /* sold out: leave the native behaviour alone */
      setLoading(true);
      /* if a later listener cancelled this submit, no navigation happens, so drop the spinner */
      setTimeout(() => { if (e.defaultPrevented) setLoading(false); }, 0);
    }, true);
    if (loadReset) {
      window.removeEventListener('pageshow', loadReset.show);
      document.removeEventListener('visibilitychange', loadReset.vis);
    }
    loadReset = {
      show: (e) => { if (e.persisted) setLoading(false); },
      vis: () => {
        if (document.visibilityState === 'hidden') { wasHidden = true; return; }
        if (wasHidden) { wasHidden = false; setLoading(false); }
      }
    };
    window.addEventListener('pageshow', loadReset.show);
    document.addEventListener('visibilitychange', loadReset.vis);
    render(false);

    /* sticky buy bar: after the hero, hidden while the buy box is on screen */
    const hero = root.querySelector('[data-ara-hero]') || document.querySelector('[data-ara-hero]');
    if (io && bar && hero && buy) {
      let heroOut = false;
      let buyIn = false;
      const barLink = bar.querySelector('a');
      /* bar height for the mobile accessibility-widget lift in the CSS */
      const setBarH = () => document.documentElement.style.setProperty('--ara-bar-h', bar.offsetHeight + 'px');
      /* before the bar goes inert, hand focus to the matching buy-box control so it is not lost */
      const handOffFocus = () => {
        const a = document.activeElement;
        if (!a || !bar.contains(a)) return;
        let t = null;
        if (a === barFlav) t = chips.find((c) => c.checked);
        else if (freqOpts.includes(a)) t = freq;
        else if (barPlans.includes(a)) t = planInputs.find((i) => i.checked);
        else if (a === barQty || barSteps.includes(a)) t = qtyInput;
        else if (a === barSubmit) t = submit;
        const tryFocus = (el) => { if (!el) return false; el.focus({ preventScroll: true }); return document.activeElement === el; };
        if (tryFocus(t) || tryFocus(submit)) return;
        if (!buy.hasAttribute('tabindex')) buy.setAttribute('tabindex', '-1');
        tryFocus(buy);
      };
      const sync = () => {
        const on = heroOut && !buyIn;
        if (!on) { handOffFocus(); closeFreq(false); }
        bar.classList.toggle('ara-show', on);
        bar.setAttribute('aria-hidden', String(!on));
        if (barLink) barLink.tabIndex = on ? 0 : -1;
        bar.inert = !on;
        setBarH();
      };
      if (barResize) window.removeEventListener('resize', barResize);
      barResize = setBarH;
      window.addEventListener('resize', barResize, { passive: true });
      new IntersectionObserver((es) => { heroOut = !es[0].isIntersecting; sync(); }).observe(hero);
      new IntersectionObserver((es) => { buyIn = es[0].isIntersecting; sync(); }, { threshold: 0.15 }).observe(buy);
    }
  }

  const boot = () => document.querySelectorAll('[data-ara-story]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', (e) => init(e.target.querySelector('[data-ara-story]')));
})();
